import { EmptyState } from '@uag/react-core';
import { useCallback } from 'react';

import { ArticleModelLifeCycleCode, type ArticleModel } from 'api/models';
import { ArticleTableRow } from 'app/modules/wallforming/components/catalogue-container/ArticleTableRow';

import type { AccessorKeyColumnDefBase, IdIdentifier, Row } from '@tanstack/react-table';

import 'app/modules/wallforming/custom-styles/customCatalogueStyle.css';

interface CatalogueArticleTableBodyProps {
    articleTableRows: Row<ArticleModel>[];
    columns: (
        | (AccessorKeyColumnDefBase<ArticleModel, string> & Partial<IdIdentifier<ArticleModel, string>>)
        | (AccessorKeyColumnDefBase<ArticleModel, ArticleModelLifeCycleCode | undefined> &
              Partial<IdIdentifier<ArticleModel, ArticleModelLifeCycleCode | undefined>>)
    )[];
}

export const CatalogueArticleTableBody = ({ articleTableRows, columns }: CatalogueArticleTableBodyProps) => {
    const handlePointerOver = useCallback((): void => {
        document.body.style.cursor = 'pointer';
    }, []);

    const handlePointerOut = useCallback((): void => {
        document.body.style.cursor = 'auto';
    }, []);

    return (
        <tbody
            className="w-full overflow-scroll max-w-full"
            onPointerOut={handlePointerOut}
            onPointerOver={handlePointerOver}
        >
            {articleTableRows.length === 0 ? (
                <tr>
                    <td colSpan={columns.length}>
                        <EmptyState className="empty-state" type="search" />
                    </td>
                </tr>
            ) : (
                articleTableRows.map((row) => (
                    <tr
                        key={row.id}
                        className="w-full h-10 max-h-10 p-0 border-b border-border-light bg-background-default"
                    >
                        <td className="p-0 h-10 max-h-10" colSpan={columns.length}>
                            <ArticleTableRow key={row.original.id} articleModel={row.original} />
                        </td>
                    </tr>
                ))
            )}
        </tbody>
    );
};
